<template>
  <div class="container-custom">
    <Breadscrumbs
      :links="[
        { name: 'Sports Lottery', to: { path: '/sports-lottery' } },
        { name: 'Create', to: { path: '/sports-lottery/create' } },
      ]"
    ></Breadscrumbs>
    <!-- page-actions -->
    <div class="page-actions">
      <h2>新增文章</h2>
      <v-spacer></v-spacer>
      <button class="btn mr-5" @click="cancelHandler">
        <span>取消</span>
      </button>
      <button class="btn btn-primary" @click="saveHandler">
        <span>儲存</span>
      </button>
    </div>

    <!-- Block 新增文章 -->
    <SportsLotteryCreateEdit></SportsLotteryCreateEdit>
  </div>
</template>

<script>
import Breadscrumbs from '@/components/Breadscrumbs.vue';
import SportsLotteryCreateEdit from '@/views/B-7__SportsLottery/c/SportsLotteryInfoCreateEdit.vue';

export default {
  components: {
    Breadscrumbs,
    SportsLotteryCreateEdit,
  },
  methods: {
    cancelHandler() {
      this.$router.go(-1);
    },
    saveHandler() {
      this.$router.go(-1);
    },
  },
};
</script>

<style></style>
